module.exports = __webpack_public_path__ + "static/media/View_Pic_Grey.2a8fd11e.svg";